import { Typography, type TypographyProps } from '../../typography/Typography';

export interface ListItemTitleProps extends Omit<
  TypographyProps<'div'>,
  'component' | 'overflow' | 'textOverflow'
> {}

export const ListItemTitle = ({ children, lineClamp = 1, ...props }: ListItemTitleProps) => (
  <Typography
    color='text.primary'
    fontSize='16px'
    lineHeight='24px'
    {...props}
    component='div'
    lineClamp={lineClamp}
    overflow='hidden'
    textOverflow='ellipsis'
  >
    {children}
  </Typography>
);
